function Navigation(){
    return (
      <div
        className="d-none d-md-flex flex-column flex-shrink-0 p-3 box-shadow"
        style={{ width: 180 }}
        id="sidebar"
      >
        <ul className="nav nav-pills flex-column mb-auto quint">
          <li>
            <a href="/" className="nav-link">
              Főoldal
            </a>
          </li>
          <hr />
          <li>
            <a href="/bemutatkozas" className="nav-link">
              Bemutatkozás
            </a>
          </li>
          <hr />
          <li>
            <a href="/shiatsu-technika" className="nav-link">
              Shiatsu technika
            </a>
          </li>
          <hr />
          <li>
            <a href="/kronobiologia" className="nav-link">
              Kronobiológia
            </a>
          </li>
          <hr />
          <li>
            <a href="/bowen-kezeles" className="nav-link">
              Bowen-kezelés
            </a>
          </li>
          <hr />
          <li>
            <a href="/indiai-fejmasszazs" className="nav-link">
              Indiai fejmasszázs
            </a>
          </li>
          <hr />
          <li>
            <a href="/metamorf-erintes" className="nav-link">
              Metamorf érintés
            </a>
          </li>
          <hr />
          <li>
            <a href="/arlista" className="nav-link">
              Árlista
            </a>
          </li>
          <hr />
          <li>
            <a href="/elerhetosegek" className="nav-link">
              Elérhetőségek
            </a>
          </li>
        </ul>
      </div>
    );
}

export default Navigation;